import "bootstrap/dist/css/bootstrap.min.css";
import { useState, useEffect, useMemo } from "react";
import { motion } from "framer-motion";

import Footer from "./components/Footer";
import {
  stepsItems,
  valuesItems,
  testimonialsItems,
  benefitItems,
  bannerItems,
} from "../src/mocks/collapse-items";
import ReactPaginate from "react-paginate";

const authUrl = process.env.REACT_APP_API_ENDPOINT_AUTH;
const jobsUrl = process.env.REACT_APP_API_ENDPOINT_JOBS;
const clientId = process.env.REACT_APP_API_CLIENT_ID;
const secret = process.env.REACT_APP_API_SECRET;

function App() {
  // const baseUrl = process.env.REACT_APP_API_ENDPOINT;
  // const effectiveAccessKeys =
  //   process.env.REACT_APP_API_EFFECTIVE_ACCESS_KEYS.split(", ");
  // const captureSource = process.env.REACT_APP_API_CAPTURE_SOURCE;

  const [showLoader, setShowLoader] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [jobPositionCity, setJobPositionCity] = useState([]);
  const [selectedCityId, setSelectedCityId] = useState("");
  const [jobPositionTitle, setJobPositionTitle] = useState([]);
  const [selectedTitleId, setSelectedTitleId] = useState("");
  const [showMenu, setShowMenu] = useState(false);

  const totalJobs = [];
  const [currentValueIndex, setCurrentValueIndex] = useState(0);
  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);
  const [currentBenefitIndex, setCurrentBenefitIndex] = useState(0);

  // paginação vagas efetivas
  const [itemOffsetEffectiveJobs, setItemOffsetEffectiveJobs] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 3;
  const endOffsetEffectiveJobs = itemOffsetEffectiveJobs + itemsPerPage;

  const filteredJobs = useMemo(() => {
    return jobs.filter((job) => {
      const matchesCity =
        !selectedCityId || job.cityId === Number(selectedCityId);

      const matchesTitle =
        !selectedTitleId || job.titlePositionId === Number(selectedTitleId);

      return matchesCity && matchesTitle;
    });
  }, [jobs, selectedCityId, selectedTitleId]);

  const currentEffectiveJobs = filteredJobs.slice(
    itemOffsetEffectiveJobs,
    endOffsetEffectiveJobs,
  );
  const pageCountEffectiveJobs = Math.ceil(filteredJobs.length / itemsPerPage);

  const handlePageClickEffectiveJobs = (event) => {
    const newOffset = (event.selected * itemsPerPage) % filteredJobs.length;
    setItemOffsetEffectiveJobs(newOffset);

    document.getElementById("oportunidades").scrollIntoView();
  };

  const handleRightClick = () => {
    if (currentValueIndex + 4 < valuesItems.length) {
      setCurrentValueIndex(currentValueIndex + 1);
    }
  };

  const handleLeftClick = () => {
    if (currentValueIndex > 0) {
      setCurrentValueIndex(currentValueIndex - 1);
    }
  };

  const handleTestimonialRightClick = () => {
    if (currentTestimonialIndex + 3 < testimonialsItems.length) {
      setCurrentTestimonialIndex(currentTestimonialIndex + 1);
    }
  };

  const handleTestimonialLeftClick = () => {
    if (currentTestimonialIndex > 0) {
      setCurrentTestimonialIndex(currentTestimonialIndex - 1);
    }
  };

  const handleBenefitRightClick = () => {
    if (currentBenefitIndex + 6 < benefitItems.length) {
      setCurrentBenefitIndex(currentBenefitIndex + 1);
    }
  };

  const handleBenefitLeftClick = () => {
    if (currentBenefitIndex > 0) {
      setCurrentBenefitIndex(currentBenefitIndex - 1);
    }
  };

  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTextIndex((prevIndex) =>
        prevIndex === bannerItems.length - 1 ? 0 : prevIndex + 1,
      );
    }, 10000);

    return () => clearInterval(interval);
  }, [bannerItems.length]);

  const currentText = bannerItems[currentTextIndex];

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };
  const closeMenu = () => {
    setShowMenu(false);
  };

  const generateNonce = () => {
    const nonce = Math.floor(Math.random() * 1000000000);
    return nonce;
  };

  const generateTimestamp = () => {
    const timestamp = Math.floor(Date.now() / 1000).toString();
    return timestamp;
  };

  const onChangeFilterJobsCity = ($event) => {
    setItemOffsetEffectiveJobs(0);
    setCurrentPage(0);

    setSelectedCityId($event.target.value);
  };

  const onChangeFilterJobsTitle = ($event) => {
    setItemOffsetEffectiveJobs(0);
    setCurrentPage(0);

    setSelectedTitleId($event.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoader(true);

      let retries = 0;
      let success = false;

      while (retries <= 2 && !success) {
        try {
          let token = localStorage.getItem("api_token");
          let storedNonce =
            localStorage.getItem("api_nonce") || generateNonce();
          let storedTimestamp =
            localStorage.getItem("api_timestamp") || generateTimestamp();

          if (!token) {
            const authResponse = await fetch(`${authUrl}`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Nonce": storedNonce,
                "X-Timestamp": storedTimestamp,
              },
              body: JSON.stringify({
                clientId: clientId,
                secret: secret,
              }),
            });

            if (!authResponse.ok) throw new Error("Erro na autenticação");

            const authData = await authResponse.json();
            token = authData.token;

            localStorage.setItem("api_token", token);
            localStorage.setItem("api_nonce", storedNonce);
            localStorage.setItem("api_timestamp", storedTimestamp);
          }

          const dataResponse = await fetch(`${jobsUrl}`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              "X-Target": "carreiras",
              "X-Nonce": storedNonce,
              "X-Timestamp": storedTimestamp,
            },
          });

          if (dataResponse.status === 401) {
            localStorage.clear();

            retries++;
            continue;
          }

          if (!dataResponse.ok) throw new Error("Erro ao buscar dados");

          const jobsData = await dataResponse.json();

          setJobs(jobsData.jobPositionList);
          setJobPositionCity(jobsData.cityList);
          setJobPositionTitle(jobsData.titlePositionList);

          success = true;
        } catch (error) {
          console.error("Erro no fluxo:", error);
          retries++;
        }
      }

      setShowLoader(false);
    };

    fetchData();
  }, []);

  const images = [
    "./assets/images/carrousel/carousel-image-1.png",
    "./assets/images/carrousel/carousel-image-2.png",
    "./assets/images/carrousel/carousel-image-3.png",
    "./assets/images/carrousel/carousel-image-4.png",
    "./assets/images/carrousel/carousel-image-5.png",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1,
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1,
    );
  };

  const items = [
    {
      id: 1,
      minimized: "./assets/images/collapse-image-1.png",
      expanded: "./assets/images/expanded-image-1.png",
    },
    {
      id: 2,
      minimized: "./assets/images/collapse-image-2.png",
      expanded: "./assets/images/expanded-image-2.png",
    },
    {
      id: 3,
      minimized: "./assets/images/collapse-image-3.png",
      expanded: "./assets/images/expanded-image-3.png",
    },
    {
      id: 4,
      minimized: "./assets/images/collapse-image-4.png",
      expanded: "./assets/images/expanded-image-4.png",
    },
    {
      id: 5,
      minimized: "./assets/images/collapse-image-5.png",
      expanded: "./assets/images/expanded-image-5.png",
    },
    {
      id: 6,
      minimized: "./assets/images/collapse-image-6.png",
      expanded: "./assets/images/expanded-image-6.png",
    },
    {
      id: 7,
      minimized: "./assets/images/collapse-image-7.png",
      expanded: "./assets/images/expanded-image-7.png",
    },
    {
      id: 8,
      minimized: "./assets/images/collapse-image-8.png",
      expanded: "./assets/images/expanded-image-8.png",
    },
  ];

  return (
    <div>
      <nav className="bg-[#2074D9] h-22">
        <div className="flex items-center justify-around p-4 pr-[10%] relative">
          <div>
            <img
              src="./assets/icons/randstad-logo-2.svg"
              alt="Randstad Logo"
              className="h-26"
            />
          </div>

          <div
            className="burguer-menu cursor-pointer mb-1"
            onClick={toggleMenu}
          >
            <img
              src="./assets/icons/Menu.svg"
              alt="menu"
              className="rounded-none"
            />
          </div>

          <ul
            id="content-burger-menu"
            className={`${"flex flex-row justify-end items-center gap-8 list-meu w-1/2"} ${
              showMenu ? "show" : ""
            }`}
          >
            <li>
              <a
                href="#nossos-valores"
                className="text-white"
                onClick={closeMenu}
              >
                valores
              </a>
            </li>
            <li>
              <a href="#sobre-nos" className="text-white" onClick={closeMenu}>
                sobre nós
              </a>
            </li>
            <li>
              <a
                href="#rands-academy"
                className="text-white"
                onClick={closeMenu}
              >
                rands academy
              </a>
            </li>
            <li>
              <a href="#areas" className="text-white" onClick={closeMenu}>
                áreas
              </a>
            </li>
            <li>
              <a href="#selecao" className="text-white" onClick={closeMenu}>
                seleção
              </a>
            </li>
            <li>
              <a href="#depoimentos" className="text-white" onClick={closeMenu}>
                depoimentos
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <div className="w-full flex justify-center items-center bg-[#2175D9] pt-[60px] max-[768px]:pt-0">
        <div className="w-[100%] max-[768px]:w-full relative">
          <div
            id="main-title"
            className="absolute top-0 left-0 flex flex-col items-start z-10 w-[55%] p-4 max-[768px]:hidden"
          >
            <motion.p className="text-white text-5xl font-light ml-[15%] mt-[-2%] max-[768px]:text-xl max-[1366px]:text-3xl">
              {currentText.title}
            </motion.p>
            <motion.p className="text-white text-5xl font-light ml-[15%] max-[1366px]:text-3xl">
              {currentText.subtitle}
            </motion.p>

            {currentText.thirdTitle && (
              <motion.p className="text-white text-5xl font-light ml-[15%] max-[1366px]:text-3xl">
                {currentText.thirdTitle}
              </motion.p>
            )}

            <motion.p
              className="text-white text-xl font-light ml-[15%] mt-[2%] max-[1366px]:hidden max-[768px]:ml-[30%]"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 1, delay: 0.4 }}
            >
              {currentText.description}
            </motion.p>
            <motion.img
              src={currentText.imageSrc}
              alt="Icon Banner"
              className="w-[40%] ml-[15%] mt-8 max-[1366px]:w-[60%]"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 1, delay: 0.6 }}
            />
            <a
              href="#oportunidades"
              className="ml-[15%] mt-[3%] mb-[5%] hidden md:block"
            >
              <button className="bg-[#262D77] px-14 text-white w-full h-[55px] rounded-md hover:bg-blue-600 max-[768px]:w-full">
                {currentText.buttonText}
              </button>
            </a>
          </div>
          <motion.img
            src={
              isMobile
                ? currentText.imageBackgroundResponsive
                : currentText.imageBackground
            }
            alt="Carreiras"
            className="w-full"
            initial={{ opacity: 0, scale: 0.98 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 1.05 }}
            transition={{ opacity: { duration: 1 }, scale: { duration: 1.5 } }}
          />
        </div>
      </div>

      <div
        id="sobre-nos"
        className="flex w-full mt-[5%] gap-5 py-14 px-[7vw] max-[768px]:flex-col !pt-0 justify-center items-center"
      >
        <div className="w-[40%] max-[768px]:w-full">
          <img
            src="./assets/images/banner-7.png"
            alt="Banner Randstad"
            className="w-full"
          />
        </div>

        <div className="w-[60%] flex flex-col max-[768px]:w-full max-[768px]:ml-0">
          <h1 className="text-4xl font-light text-[#1E1E1E] mb-4">
            somos a líder global em soluções completas de recursos humanos
          </h1>
          <div className="space-y-2 mb-6">
            <p className="font-light text-[#262729]">
              Fundada em 1960 na Holanda, estamos há mais de 60 anos levando
              pessoas e empresas adiante. Atualmente estamos presentes em 39
              países. Para atender nossos clientes e candidatos, contamos com
              mais de 40 mil colaboradores e empregamos diariamente 650 mil
              pessoas ao redor do mundo.
            </p>
            <p className="font-light text-[#262729]">
              Estamos desde 2011 transformando o mercado brasileiro com inovação
              e assertividade. Temos orgulho de conectar pessoas à oportunidades
              em todo o Brasil. Hoje somos mais de 800 colaboradores que atendem
              empresas em todo o país.
            </p>
            <div className="grid grid-cols-6 gap-2 justify-center pt-8 max-[1440px]:grid-cols-3">
              {[
                {
                  icon: "./assets/icons/randstad-icons/icon-1.svg",
                  title: "1º Player Global",
                },
                {
                  icon: "./assets/icons/randstad-icons/icon-2.svg",
                  title: "Presença em 39 países",
                },
                {
                  icon: "./assets/icons/randstad-icons/icon-3.svg",
                  title: "Presença em todos os estados Brasileiros",
                },
                {
                  icon: "./assets/icons/randstad-icons/icon-4.svg",
                  title: "+ de 800 colaboradores espalhados pelo Brasil",
                },
                {
                  icon: "./assets/icons/randstad-icons/icon-5.svg",
                  title: "+ de 50 mil vagas preenchidas em 2023",
                },
                {
                  icon: "./assets/icons/randstad-icons/icon-6.svg",
                  title: "Desde 2011 no Brasil",
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="w-full h-[120px] p-2 flex flex-col text-white bg-[#2175D9] rounded-lg shadow-md"
                >
                  <div className="h-1/2 w-full flex justify-center items-center">
                    <img
                      src={item.icon}
                      alt={item.title}
                      className="h-[35px]"
                    />
                  </div>
                  <div className="h-1/2 w-full flex justify-center items-center">
                    <h3 className="text-center text-[11px]">{item.title}</h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div
        className="flex w-full gap-6 py-14 px-[7vw] max-[768px]:flex-col !pt-0 justify-center items-center mt-[5%]"
        id="sobre"
      >
        <div className="flex flex-col w-[55%] max-[768px]:w-full">
          <h1 className="text-3xl text-black font-light mb-6">
            partner <span className="text-blue-500">for talent</span>
          </h1>
          <p className="text-lg font-light text-[#262729] mr-[20%] max-[768px]:mr-0">
            Ajudamos você a encontrar o trabalho certo, garantindo funções
            significativas para desenvolver competências relevantes que ajudem
            no desenvolvimento de sua carreira.
          </p>
        </div>

        <div className="w-[45%] h-auto max-[768px]:w-full">
          <img
            src="./assets/images/banner-2.png"
            alt="Carreiras"
            className="w-full"
          />
        </div>
      </div>

      <div className="w-full bg-[#2074D9] flex justify-center items-center max-[768px]:hidden">
        <div className="w-[100%] max-[768px]:w-full relative">
          <div
            id="main-title"
            className="absolute top-1/2 left-0 transform -translate-y-1/2 flex flex-col items-start z-10 w-[55%] p-4 max-[768px]:hidden"
          >
            <p className="text-white text-5xl font-light ml-[8%] max-[768px]:text-xl">
              nosso propósito
            </p>
            <p className="text-white text-xl font-light ml-[8%] mt-[2%] mr-[30%] max-[768px]:text-sm max-[768px]:ml-[30%]">
              Apoiar pessoas na realização do seu verdadeiro potencial, ao longo
              da sua vida profissional.
            </p>
          </div>
          <img
            src="./assets/images/banner-3.png"
            alt="Carreiras"
            className="w-full"
          />
        </div>
      </div>

      <div id="nossos-valores" className="bg-[#645CFE] bg-opacity-5">
        <div className="flex justify-between items-center py-12 px-[7vw] max-[768px]:justify-center">
          <h1 className="text-4xl font-light text-[#042552]">nossos valores</h1>
          <div className="flex flex-row max-[768px]:hidden">
            <img
              src="./assets/icons/left-blue-sign.svg"
              alt="Left Sign"
              onClick={handleLeftClick}
              className={`w-9 h-9 object-contain rounded-sm mr-4 border-[0.1px] border-[#2175D9] p-2 cursor-pointer ${
                currentValueIndex === 0 ? "opacity-50 cursor-not-allowed" : ""
              }`}
            />
            <img
              src="./assets/icons/right-blue-sign.svg"
              alt="Right Sign"
              onClick={handleRightClick}
              className={`w-9 h-9 object-contain rounded-sm border-[0.1px] border-[#2175D9] p-2 cursor-pointer ${
                currentValueIndex + 4 >= valuesItems.length
                  ? "opacity-50 cursor-not-allowed"
                  : ""
              }`}
            />
          </div>
        </div>

        <div className="flex flex-wrap gap-6 px-[7vw] max-[768px]:flex-col pb-[5%] md:hidden">
          {valuesItems
            .slice(currentValueIndex, currentValueIndex + 6)
            .map((item, index) => (
              <div
                key={index}
                className="h-auto bg-white flex-1 rounded-lg shadow-sm"
              >
                <img
                  src={item.icon}
                  alt="Icon"
                  className="w-[90px] pl-6 mt-8"
                />
                <h1 className="text-lg font-regular text-[#042552] mb-4 pl-6 mt-2">
                  {item.title}
                </h1>
                <p className="text-[#042552] text-sm pl-6 px-8 pb-6">
                  {item.description}
                </p>
              </div>
            ))}
        </div>

        <div className="flex flex-wrap gap-6 px-[7vw] max-[768px]:flex-col pb-[5%] max-[768px]:hidden">
          {valuesItems
            .slice(currentValueIndex, currentValueIndex + 4)
            .map((item, index) => (
              <div
                key={index}
                className="h-auto bg-white flex-1 rounded-lg shadow-sm"
              >
                <img
                  src={item.icon}
                  alt="Icon"
                  className="w-[90px] pl-6 mt-8"
                />
                <h1 className="text-lg font-regular text-[#042552] mb-4 pl-6 mt-2">
                  {item.title}
                </h1>
                <p className="text-[#042552] text-sm pl-6 px-8 pb-6">
                  {item.description}
                </p>
              </div>
            ))}
        </div>
      </div>

      <div className="pb-24 pt-12 bg-opacity-5 max-[768px]:pb-0">
        <h1 className="text-4xl font-light text-center text-[#042552] mb-12 px-[7vw]">
          especializações
        </h1>

        <div className="w-full flex justify-center items-center">
          <div className="relative flex justify-center items-center w-[80%] max-[768px]:w-full">
            <div
              onClick={goToPrevious}
              className="absolute left-[0%] top-1/2 transform -translate-y-1/2 z-10 cursor-pointer"
            >
              <img
                src="./assets/icons/chevron-left.svg"
                alt="Previous"
                className="w-8 h-8"
              />
            </div>

            <div className="w-full relative flex justify-center">
              <img
                src={images[currentIndex]}
                alt="Banner"
                className="w-full max-w-[90%] rounded-xl"
              />
            </div>

            <div
              onClick={goToNext}
              className="absolute right-[0%] top-1/2 transform -translate-y-1/2 z-10 cursor-pointer"
            >
              <img
                src="./assets/icons/chevron-right.svg"
                alt="Next"
                className="w-8 h-8"
              />
            </div>
          </div>
        </div>

        <h1 className="text-2xl font-light text-center text-[#2175D9] mt-12 mb-8 px-[7vw]">
          Diversidade, Equidade, Inclusão e Pertencimento.
        </h1>

        <div className="flex items-center justify-center">
          <img
            src="./assets/icons/deip-logo.png"
            alt="Banner Randstad"
            className="h-24 w-44 flex justify-center"
          />
          <h1 className="text-3xl font-light text-center text-[#000000] ml-4">
            DEI&P
          </h1>
        </div>

        <p className="text-md font-light text-left mt-12 text-[#262729] mx-48 max-[768px]:mx-6">
          Pessoas são únicas e com suas diferenças. Como empresa temos que
          exercer um papel importante para uma sociedade mais justa e
          igualitária, trabalhando os princípios de diversidade, equidade,
          inclusão e pertencimento. O respeito à diversidade vai além das
          necessidades do negócio, é sobre pessoas, por isso, temos o objetivo
          de ser uma empresa com cada vez mais representatividade e um ambiente
          mais inclusivo e acolhedor.
        </p>

        <p className="text-md font-light text-left text-[#262729] mx-48 max-[768px]:mx-6">
          Para isso, temos 5 grupos de afinidades para falar de temas
          relacionados a DEI&P.
        </p>

        <div className="flex flex-wrap justify-center">
          {[
            "./assets/icons/diversity-icons/logo-1.svg",
            "./assets/icons/diversity-icons/logo-2.svg",
            "./assets/icons/diversity-icons/logo-3.svg",
            "./assets/icons/diversity-icons/logo-4.svg",
            "./assets/icons/diversity-icons/logo-5.svg",
          ].map((icon, index) => (
            <div
              key={index}
              className="flex justify-center items-center p-2 max-[768px]:w-[60%]"
            >
              <img src={icon} alt={`Icon ${index + 1}`} className="w-full" />
            </div>
          ))}
        </div>

        <div
          id="dna"
          className="flex w-full mt-[2%] py-14 max-[768px]:flex-col !pt-0 justify-center items-center max-[768px]:px-4"
        >
          <div className="flex w-[30%] max-[768px]:w-full items-stretch">
            <img
              src="./assets/images/banner-9.png"
              alt="Banner Randstad"
              className="w-full object-cover max-[768px]:h-[350px]"
            />
          </div>

          <div className="w-[55%] flex flex-col ml-6 max-[768px]:w-full max-[768px]:ml-0">
            <div className="space-y-2 mb-6">
              <p className="font-light text-[#262729]  max-[768px]:mt-8">
                Na Randstad temos a preocupação e o cuidado em oferecer uma
                experiência cada vez mais positiva à todos os nossos
                colaboradores, por isso temos uma proposta de valor ao
                colaborador que está estruturada em 5 pilares:
              </p>

              <div className="flex">
                <img
                  src="./assets/icons/bullet-point.svg"
                  className="h-6 w-4 mr-4"
                  alt="Propósito"
                />
                <span className="font-light text-[#262729]">Propósito</span>
              </div>

              <div className="flex">
                <img
                  src="./assets/icons/bullet-point.svg"
                  className="h-6 w-4 mr-4"
                  alt="Cultura"
                />
                <span className="font-light text-[#262729]">Cultura</span>
              </div>

              <div className="flex">
                <img
                  src="./assets/icons/bullet-point.svg"
                  className="h-6 w-4 mr-4"
                  alt="Crescimento e carreira"
                />
                <span className="font-light text-[#262729]">
                  Crescimento e carreira
                </span>
              </div>

              <div className="flex">
                <img
                  src="./assets/icons/bullet-point.svg"
                  className="h-6 w-4 mr-4"
                  alt="Bem-estar"
                />
                <span className="font-light text-[#262729]">Bem-estar</span>
              </div>

              <div className="flex">
                <img
                  src="./assets/icons/bullet-point.svg"
                  className="h-6 w-4 mr-4"
                  alt="Recompensa"
                />
                <span className="font-light text-[#262729]">Recompensa</span>
              </div>

              <p className="font-light text-[#262729] pt-2">
                Nosso EVP reflete o empenho em criar um ambiente de trabalho
                cada vez mais inspirador, inclusivo e que ofereça as melhores
                oportunidades para o crescimento de todos, oferecendo
                recompensas significativas, competitivas e equitativas pelos
                esforços e desempenho de cada colaborador. Além disso,
                valorizamos o equilíbrio entre vida pessoal e profissional e
                vivenciamos nossa cultura em tudo que fazemos. Para isso,
                oferecemos diversos benefícios capazes de melhorar a sua
                experiência na empresa.
              </p>

              <div className="flex flex-wrap justify-center pt-2">
                <div className="flex justify-center flex-wrap overflow-hidden max-md:hidden">
                  <div
                    onClick={handleBenefitLeftClick}
                    className={`flex items-center cursor-pointer max-md:hidden ${
                      currentBenefitIndex === 0
                        ? "opacity-50 cursor-not-allowed"
                        : ""
                    }`}
                  >
                    <img
                      src="./assets/icons/chevron-left.svg"
                      alt="Previous"
                      className="w-6 h-6"
                    />
                  </div>

                  {benefitItems
                    .slice(currentBenefitIndex, currentBenefitIndex + 6)
                    .map((item, index) => (
                      <div
                        key={index}
                        className="w-[110px] h-[130px] mb-2 mx-0.5 flex flex-col justify-center items-center text-white pt-2 bg-[#2175D9] rounded-lg shadow-md max-[1024px]:w-[25%] max-[768px]:w-[40%] max-[480px]:w-[80%]"
                      >
                        <div className="flex flex-col items-center">
                          <img
                            src={item.icon}
                            alt={item.title}
                            className="w-10 h-10 mb-2"
                          />
                          <h3 className="text-center text-[10px] p-1 font-regular">
                            {item.title}
                          </h3>
                        </div>
                      </div>
                    ))}

                  <div
                    onClick={handleBenefitRightClick}
                    className={`flex items-center cursor-pointer max-md:hidden ${
                      currentBenefitIndex + 6 >= benefitItems.length
                        ? "opacity-50 cursor-not-allowed"
                        : ""
                    }`}
                  >
                    <img
                      src="./assets/icons/chevron-right.svg"
                      alt="Next"
                      className="w-6 h-6"
                    />
                  </div>
                </div>

                <div className="flex justify-center flex-wrap md:hidden">
                  {benefitItems.map((item, index) => (
                    <div
                      key={index}
                      className="w-[120px] mb-2 mx-0.5 flex flex-col justify-center items-center text-white pt-3 bg-[#2175D9] rounded-lg h-42 shadow-md max-[1024px]:w-[25%] max-[768px]:w-[40%] max-[480px]:w-[80%]"
                    >
                      <div className="flex flex-col items-center">
                        <img
                          src={item.icon}
                          alt={item.title}
                          className="w-10 h-10 mb-2"
                        />
                        <h3 className="text-center text-xs p-2 font-regular">
                          {item.title}
                        </h3>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="rands-academy"
        className="w-full bg-[#2074D9] flex justify-center items-center max-[768px]:hidden"
      >
        <div className="w-[100%] max-[768px]:w-full relative">
          <div
            id="main-title"
            className="absolute top-1/2 left-0 transform -translate-y-1/2 flex flex-col items-start z-10 w-[70%] p-4 max-[768px]:hidden"
          >
            <p className="text-white text-5xl font-light ml-[8%] max-[768px]:text-xl">
              rands academy
            </p>
            <p className="text-white text-md font-light ml-[8%] mt-[2%] mr-[30%] max-[768px]:text-sm max-[768px]:ml-[30%]">
              Temos uma plataforma de educação corporativa exclusiva.
              <p className="mt-2">
                A Rands Academy, em parceria com a Udemy - uma das maiores
                empresas de ensino digital do mundo - disponibiliza milhares de
                cursos para que nossos talentos internos aprimorem seus
                conhecimentos e trilhem um futuro brilhante.
              </p>
              <p className="mt-2">
                Para apoiar o desenvolvimento através da Rands Academy, nossos
                talentos podem usufruir do “learning time”, que é 1 hora por
                semana, dentro da jornada de trabalho, para focar nos estudos na
                plataforma.
              </p>
              <a href="#oportunidades" className="mt-[5%] mb-[5%]">
                <button className="border border-white text-white px-8 mt-[5%] h-[55px] rounded-md hover:bg-white hover:text-[#2175D9] max-[768px]:w-full">
                  entre para nosso time
                </button>
              </a>
            </p>
          </div>
          <img
            src="./assets/images/banner-6.png"
            alt="Carreiras"
            className="w-full"
          />
        </div>
      </div>

      <div
        id="dna"
        className="flex  bg-[#FAFBFC] w-full mt-[5%] gap-6 py-14 px-[7vw] max-[768px]:flex-col !pt-0 justify-center items-center max-[768px]:py-0"
      >
        <div className="w-[50%] max-[768px]:w-full">
          <img
            src="./assets/images/banner-4.png"
            alt="Carreiras"
            className="w-full h-[90%]"
          />
        </div>

        <div className="w-[50%] ml-12 flex flex-col max-[768px]:w-full max-[768px]:ml-0">
          <h1 className="text-3xl font-regular text-[#042552] mb-4">
            encontre-nos no Glassdoor
          </h1>
          <div className="space-y-2 mb-6">
            <p className="text-md font-light text-[#262729]">
              Na Randstad, temos um compromisso com a transparência e
              experiência dos nossos colaboradores, e para as pessoas candidatas
              que buscam conhecer um pouco mais sobre o nosso jeito de ser, nós
              aderimos ao selo Open Company e temos uma página disponível no
              Glassdoor.
            </p>
            <p className="text-md font-light text-[#262729]">
              Você pode conferir nossas práticas e benefícios do ponto de vista
              dos nossos talentos, e concluir se a nossa cultura tem match com o
              seus valores.
            </p>
            <a
              href="https://www.glassdoor.com.br/Vis%C3%A3o-geral/Trabalhar-na-Randstad-EI_IE302306.13,21.htm"
              target="_blank"
              rel="noreferrer"
              className="mt-[10%] mb-[5%]"
            >
              <button className="bg-[#2175D9] px-8 text-white mt-[5%] h-[55px] rounded-md hover:bg-blue-600 max-[768px]:w-full">
                confira nossa página no glassdoor
              </button>
            </a>
          </div>
        </div>
      </div>

      <div
        id="areas"
        className="flex w-full mt-[3%] px-[4vw] max-[768px]:flex-col !pt-0 justify-center items-center"
      >
        <div className="w-full bg-[#FFFFFF] ml-12 flex flex-col max-[768px]:w-full max-[768px]:ml-0">
          <h1 className="text-4xl font-light justify-center flex text-[#042552] mb-10">
            áreas de atuação
          </h1>

          <div
            className={`flex ${
              isMobile
                ? "flex-wrap h-auto gap-2"
                : "overflow-hidden h-[500px] gap-1"
            } mb-24`}
          >
            {items.map((image, index) => (
              <div
                key={image.id}
                className={`relative ${
                  isMobile
                    ? "flex-[0_0_calc(25%-0.5rem)]"
                    : `flex-grow transition-all duration-500 ease-in-out ${
                        hoveredIndex === index
                          ? "basis-[80%]"
                          : hoveredIndex === null
                            ? "basis-[45%]"
                            : "basis-[12.5%]"
                      }`
                }`}
                onMouseEnter={() => !isMobile && setHoveredIndex(index)}
                onMouseLeave={() => !isMobile && setHoveredIndex(null)}
              >
                <img
                  src={
                    isMobile || hoveredIndex !== index
                      ? image.minimized
                      : image.expanded
                  }
                  alt={`Banner ${index + 1}`}
                  className={`w-full h-full object-contain ${
                    !isMobile ? "transition-all duration-500 ease-in-out" : ""
                  }`}
                />
              </div>
            ))}
          </div>

          <h1
            id="selecao"
            className="text-4xl font-light justify-center flex text-[#042552] mb-20 max-[768px]:mb-6 max-[768px]:mx-4 max-[768px]:text-center"
          >
            conheça o passo a passo da seleção dos nossos talentos
          </h1>

          <div className="grid gap-4 sm:grid-cols-1 lg:grid-cols-6 p-2 md:hidden">
            {stepsItems.map((step, index) => (
              <div
                key={index}
                className="flex flex-col items-center bg-[#FFFFFF] rounded-lg p-4 shadow"
              >
                <img
                  src={step.icon}
                  alt="Carreiras"
                  className="h-12 bg-[#2175D9] w-14 px-[2vw]"
                />
                <div className="mt-6 text-[#042552] font-light">
                  {step.label}
                </div>
              </div>
            ))}
          </div>

          <img
            src="./assets/images/process-image.svg"
            alt="Carreiras"
            className="w-full px-[6vw] max-[768px]:hidden"
          />
        </div>
      </div>

      <div
        id="oportunidades"
        className="flex w-full bg-[#FAFBFC] mt-[5%] gap-6 py-14 px-[7vw] max-[768px]:flex-col !pt-0 justify-center items-center max-[768px]:py-0"
      >
        <div className="w-full ml-12 flex flex-col max-[768px]:w-full max-[768px]:ml-0">
          <h1 className="text-4xl flex pt-16 justify-center font-light text-[#042552] mb-4">
            faça parte do nosso time, venha para a Randstad!
          </h1>
          <div className="container mx-auto px-4 py-8">
            <div className="flex flex-wrap justify-center gap-6 max-[768px]:flex-col">
              <div className="flex max-lg:flex-col justify-between max-lg:gap-4 w-full">
                <select
                  onChange={onChangeFilterJobsCity}
                  defaultValue=""
                  className="max-lg:w-full filter-btn w-[350px] mb-4 p-2 cursor-pointer"
                >
                  <option value="">Todas as cidades</option>
                  {jobPositionCity.map((jobId, i) => (
                    <option value={jobId.id} key={i}>
                      {jobId.name}{" "}
                      {jobId.stateCode ? `- ${jobId.stateCode}` : ""}
                    </option>
                  ))}
                </select>
                <select
                  onChange={onChangeFilterJobsTitle}
                  defaultValue=""
                  className="max-lg:w-full filter-btn w-[350px] mb-4 p-2 cursor-pointer"
                >
                  <option value="">Todas os cargos</option>
                  {jobPositionTitle.map((jobId, i) => (
                    <option value={jobId.id} key={i}>
                      {jobId.name}
                    </option>
                  ))}
                </select>
              </div>
              {!showLoader && currentEffectiveJobs.length
                ? currentEffectiveJobs.map((job, i) => (
                    <div
                      key={i}
                      className="p-4 border rounded-lg bg-[#ffffff] w-[30%] max-[768px]:w-full flex flex-col"
                    >
                      <div className="flex items-start space-x-4">
                        <div>
                          <h2 className="text-lg font-light text-[#2175D9]">
                            {job.name}
                          </h2>
                        </div>
                      </div>
                      <p className="mt-2 text-sm font-regular text-[#696974] leading-6 line-clamp-5">
                        {new DOMParser().parseFromString(
                          job.description,
                          "text/html",
                        ).body.textContent || ""}
                      </p>

                      <div className="flex justify-left items-center gap-2">
                        {job.cityName && (
                          <div className="bg-[#F1F1F5] text-sm text-center text-[#696974] px-3 py-2 mb-3 rounded-md">
                            {job.cityName}
                          </div>
                        )}

                        {job.positionCode && (
                          <div className="bg-[#F1F1F5] text-sm text-center text-[#696974] px-3 py-2 mb-3 rounded-md">
                            {job.positionCode}
                          </div>
                        )}
                      </div>

                      <a
                        href={job.shortUrl}
                        rel="noreferrer"
                        target="_blank"
                        className="mt-auto"
                      >
                        <button className="bg-[#2175D9] px-8 text-white h-[45px] rounded-md hover:bg-blue-600 max-[768px]:w-full text-sm">
                          ver detalhes
                        </button>
                      </a>
                    </div>
                  ))
                : null}
            </div>
            {!showLoader && currentEffectiveJobs.length ? (
              <ReactPaginate
                containerClassName="pagination"
                breakLabel="..."
                nextLabel=">"
                onPageChange={handlePageClickEffectiveJobs}
                pageRangeDisplayed={3}
                forcePage={currentPage}
                pageCount={pageCountEffectiveJobs}
                previousLabel="<"
                renderOnZeroPageCount={null}
              />
            ) : // <nav>
            //   <ul className="w-[90%] flex flex-row items-center justify-center mt-12 max-[768px]:w-full">
            //     {currentPage !== 1 && (
            //       <li onClick={prevPage}>
            //         <a href="#oportunidades" className="control">
            //           <p>{isMobile ? "" : "Anterior"}</p>
            //           <img
            //             src="./assets/icons/arrow_left.svg"
            //             alt="anterior"
            //             className={`rounded-none ${
            //               isMobile ? "h-[14px]" : "h-[9px]"
            //             }`}
            //           />
            //         </a>
            //       </li>
            //     )}

            //     {numbers.map((n, i) => (
            //       <li key={i} onClick={() => changePage(n)}>
            //         <a
            //           href="#oportunidades"
            //           className={`page-item ${
            //             currentPage === n ? "active" : ""
            //           }`}
            //         >
            //           {n}
            //         </a>
            //       </li>
            //     ))}

            //     {currentPage < numbers.length && (
            //       <li onClick={nextPage}>
            //         <a href="#oportunidades" className="control">
            //           <p>{isMobile ? "" : "Próxima"}</p>
            //           <img
            //             src="./assets/icons/arrow_right.svg"
            //             alt="proxima"
            //             className={`rounded-none ${
            //               isMobile ? "h-[14px]" : "h-[9px]"
            //             }`}
            //           />
            //         </a>
            //       </li>
            //     )}
            //   </ul>
            // </nav>
            null}
          </div>
        </div>
      </div>

      <div
        id="depoimentos"
        className="flex w-full gap-6 py-14 px-[4vw] max-[768px]:flex-col !pt-0 justify-center items-center"
      >
        <div className="w-full bg-[#FFFFFF] ml-12 flex flex-col max-[768px]:w-full max-[768px]:ml-0">
          <div className="flex justify-between items-center py-12 px-[7vw]">
            <h1 className="text-4xl font-light text-[#042552]">
              #orgulhodepertencer
            </h1>
            <div className="flex flex-row max-[768px]:hidden">
              <img
                src="./assets/icons/left-blue-sign.svg"
                alt="Left Sign"
                onClick={handleTestimonialLeftClick}
                className={`w-9 h-9 object-contain rounded-sm mr-4 border-[0.1px] border-[#2175D9] p-2 cursor-pointer ${
                  currentTestimonialIndex === 0
                    ? "opacity-50 cursor-not-allowed"
                    : ""
                }`}
              />
              <img
                src="./assets/icons/right-blue-sign.svg"
                alt="Right Sign"
                onClick={handleTestimonialRightClick}
                className={`w-9 h-9 object-contain rounded-sm border-[0.1px] border-[#2175D9] p-2 cursor-pointer ${
                  currentTestimonialIndex + 3 >= testimonialsItems.length
                    ? "opacity-50 cursor-not-allowed"
                    : ""
                }`}
              />
            </div>
          </div>

          <div className="container mx-auto px-4 py-8 max-[768px]:px-0">
            <div className="grid grid-cols-3 gap-8 max-[768px]:grid-cols-1">
              {testimonialsItems
                .slice(
                  window.innerWidth < 768 ? 0 : currentTestimonialIndex,
                  window.innerWidth < 768
                    ? testimonialsItems.length
                    : currentTestimonialIndex + 3,
                )
                .map((testimonial, index) => (
                  <div key={index} className="p-4 border rounded-lg shadow-lg">
                    <div className="flex items-start space-x-4">
                      <img
                        src={testimonial.img}
                        alt={`Foto de ${testimonial.name}`}
                        className="w-20 h-20 rounded-full"
                      />
                      <div>
                        <h2 className="text-lg font-semibold">
                          {testimonial.name}
                        </h2>
                        <p className="text-sm text-gray-600">
                          {testimonial.role}
                        </p>
                      </div>
                    </div>
                    <p className="mt-4 text-sm text-gray-700 leading-6">
                      {testimonial.quote}
                    </p>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>

      <div className="w-full bg-[#2074D9] flex justify-center items-center max-[768px]:hidden">
        <div className="w-[100%] max-[768px]:w-full relative">
          <div
            id="main-title"
            className="absolute top-1/2 left-0 transform -translate-y-1/2 flex flex-col items-start z-10 w-[55%] p-4 max-[768px]:hidden"
          >
            <p className="text-[#2074D9] p-2.5 bg-white text-4xl font-light rounded-md ml-[12%] max-[768px]:text-xl">
              você tem dúvidas?
            </p>
            <p className="text-white p-2.5 bg-[#2074D9] text-4xl font-light ml-[35%] rounded-md mt-[2%] mr-[30%] max-[768px]:text-sm max-[768px]:ml-[30%]">
              fale conosco!
            </p>
          </div>
          <img
            src="./assets/images/banner-5.png"
            alt="Carreiras"
            className="w-full"
          />
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default App;
